import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-css",
  "use": "icon-css-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol viewBox=\"0 0 14 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-css\">\n<path d=\"M2.91617 1.83984L2.53701 3.78818H10.4645L10.2078 5.04818H2.28617L1.90117 6.99068H9.82867L9.38534 9.21318L6.18867 10.269L3.41784 9.21318L3.61034 8.25651H1.66201L1.20117 10.5898L5.78034 12.3398L11.0595 10.5898L11.7595 7.07234L11.8995 6.36651L12.7978 1.83984H2.91617Z\" fill=\"#46A0D2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol